<template>
  <v-form
    ref="form"
    v-model="isFormValid"
    :disabled="isLoading"
    @submit.prevent="() => submitForm()"
  >
    <v-container fluid>
      <v-row>
        <v-col cols="12">
          <v-text-field
            label="Nome"
            hint="Campo obrigatório"
            persistent-hint

            v-model="formFields.reportName"
            :rules="[vRules.requiredField]"
          />
        </v-col>
      </v-row>

      <v-row>
        <v-col style="max-width: 100px;">
          <v-select
            label="Relação"
            v-model="formFields.indexRelative"
            :items="indexRelativeOptions"
          />
        </v-col>

        <v-col>
          <index-selector
            label="Índice"
            hint="Campo obrigatório"
            persistent-hint

            item-value="_id"
            item-text="name"

            v-model="formFields.indexId"
            :rules="[vRules.requiredField]"
          />
        </v-col>
      </v-row>

      <v-row dense justify="end" v-if="!hideActions">
        <v-col cols="12" sm="auto">
          <v-btn
            text
            block
            color="error"
            :disabled="isLoading"
            @click="() => discardHandler()"
          >
            {{ texts.discardBtn }}
          </v-btn>
        </v-col>

        <v-col cols="12" sm="auto">
          <v-btn
            block
            color="primary"
            type="submit"
            :disabled="!isFormValid || isLoading"
            :loading="isLoading"
          >
            {{ texts.submitBtn }}
          </v-btn>
        </v-col>
      </v-row>
    </v-container>
  </v-form>
</template>

<script>
import fillSchema from '@/utils/fill-schema';
import { requiredField } from '@/utils/validators';

import IndexSelector from '@/components/global/IndexSelector.vue';

const formSchema = {
  reportName: '',
  indexId: null,
  indexRelative: true,
  fundsList: [],
};

export default {
  name: 'BoardClassForm',

  components: {
    IndexSelector,
  },

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },

    initialData: {
      type: Object,
      default: () => ({}),
    },

    hideActions: {
      type: Boolean,
      default: false,
    },

    discardBtnText: {
      type: String,
      default: null,
    },

    submitBtnText: {
      type: String,
      default: null,
    },
  },

  data: (vm) => ({
    formFields: fillSchema(formSchema, vm.initialData ?? {}),
    isFormValid: false,

    vRules: {
      requiredField,
    },

    indexRelativeOptions: [
      { value: true, text: '%' },
      { value: false, text: 'Vs' },
    ],
  }),

  computed: {
    texts: (vm) => ({
      discardBtn: vm.discardBtnText ?? 'Descartar alterações',
      submitBtn: vm.submitBtnText ?? 'Enviar',
    }),
  },

  methods: {
    discardHandler() {
      this.discardChanges();
      this.$emit('click:discard');
    },

    discardChanges() {
      this.formFields = fillSchema(formSchema, this.initialData ?? {});
    },

    submitForm() {
      this.$emit('submit', { ...this.formFields });
    },
  },
};
</script>
